(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  (() => {
    const initializeFlavorControls = (container = document) => {
      const flavorFilters = [];
      if (container.matches?.('.collection-all-flavor')) flavorFilters.push(container);
      flavorFilters.push(...container.querySelectorAll('.collection-all-flavor'));

      flavorFilters.forEach((filter) => {
        if (window.matchMedia('(min-width: 990px)').matches && filter.dataset.desktopExpanded !== 'true') {
          filter.open = true;
          filter.dataset.desktopExpanded = 'true';
        }

        const search = filter.querySelector('[data-flavor-search]');
        if (!search || search.dataset.initialized === 'true') return;
        search.dataset.initialized = 'true';

        const panel = search.closest('.collection-all-flavor__panel');
        const options = Array.from(panel?.querySelectorAll('[data-flavor-option]') || []);
        const resultCount = panel?.querySelector('[data-flavor-result-count]');

        search.addEventListener('input', () => {
          const query = search.value.trim().toLocaleLowerCase();
          let visibleCount = 0;

          options.forEach((option) => {
            const hasStock = option.dataset.hasStock !== 'false';
            const isVisible = hasStock && option.dataset.flavorLabel.toLocaleLowerCase().includes(query);
            option.hidden = !isVisible;
            if (isVisible) visibleCount += 1;
          });

          if (resultCount) resultCount.textContent = visibleCount;
        });
      });
    };

    initializeFlavorControls();

    const initializeSortButtons = (container = document) => {
      const sortGroups = [];
      if (container.matches?.('[data-sort-buttons]')) sortGroups.push(container);
      sortGroups.push(...container.querySelectorAll('[data-sort-buttons]'));

      sortGroups.forEach((group) => {
        if (group.dataset.initialized === 'true') return;

        const controls = group.closest('.collection-all-controls');
        const select = controls?.querySelector('#SortBy');
        const buttons = Array.from(group.querySelectorAll('.collection-all-sort-button'));
        if (!select || buttons.length === 0) return;
        group.dataset.initialized = 'true';

        const updateButtons = (sortValue) => {
          buttons.forEach((button) => {
            const ascendingValue = button.dataset.sortAscending;
            const descendingValue = button.dataset.sortDescending;
            const isDirectional = Boolean(ascendingValue && descendingValue);
            const isActive = isDirectional
              ? sortValue === ascendingValue || sortValue === descendingValue
              : sortValue === button.dataset.sortValue;

            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-pressed', isActive ? 'true' : 'false');

            if (!isDirectional) return;

            const usesDescending = sortValue === descendingValue ||
              (!isActive && button.dataset.sortDefault === descendingValue);
            const direction = button.querySelector('[data-sort-direction]');
            if (direction) direction.textContent = usesDescending ? '↓' : '↑';
            button.setAttribute(
              'aria-label',
              usesDescending ? button.dataset.sortLabelDescending : button.dataset.sortLabelAscending
            );
          });
        };

        buttons.forEach((button) => {
          button.addEventListener('click', () => {
            const ascendingValue = button.dataset.sortAscending;
            const descendingValue = button.dataset.sortDescending;
            let nextValue = button.dataset.sortValue;

            if (ascendingValue && descendingValue) {
              if (select.value === ascendingValue) {
                nextValue = descendingValue;
              } else if (select.value === descendingValue) {
                nextValue = ascendingValue;
              } else {
                nextValue = button.dataset.sortDefault;
              }
            }

            if (!nextValue || nextValue === select.value) return;
            select.value = nextValue;
            updateButtons(nextValue);
            select.dispatchEvent(new Event('input', { bubbles: true }));
          });
        });

        updateButtons(select.value);
      });
    };

    initializeSortButtons();

    const initializeStockCounts = (container = document) => {
      const stockCounters = [];
      if (container.matches?.('[data-stock-count-source]')) stockCounters.push(container);
      stockCounters.push(...container.querySelectorAll('[data-stock-count-source]'));

      stockCounters.forEach(async (stockCounter) => {
        if (stockCounter.dataset.stockInitialized === 'true') return;
        stockCounter.dataset.stockInitialized = 'true';

        const options = Array.from(
          stockCounter.querySelectorAll('[data-stock-count-option], [data-flavor-option]')
        );
        const counts = new Map(
          options.map((option) => [
            (option.dataset.stockCountLabel || option.dataset.flavorLabel).toLocaleLowerCase(),
            0,
          ])
        );
        const flavorFilter = stockCounter.querySelector('.collection-all-flavor');
        const loading = stockCounter.querySelector('[data-flavor-loading]');
        const content = stockCounter.querySelector('[data-flavor-content]');

        try {
          let page = 1;
          let products = [];

          do {
            const url = new URL(stockCounter.dataset.stockCountSource, window.location.origin);
            url.searchParams.set('limit', '250');
            url.searchParams.set('page', page.toString());
            const response = await fetch(url, { credentials: 'same-origin' });
            if (!response.ok) throw new Error(`Collection products returned ${response.status}`);

            products = (await response.json()).products || [];
            products.forEach((product) => {
              const hasAvailableFlower = product.variants?.some((variant) => {
                const sku = (variant.sku || '').toLocaleUpperCase();
                return variant.available && (sku.includes('FULL-OZ') || sku.includes('SMALL-OZ'));
              });
              if (!hasAvailableFlower) return;

              (product.tags || []).forEach((tag) => {
                const key = tag.trim().toLocaleLowerCase();
                if (counts.has(key)) counts.set(key, counts.get(key) + 1);
              });
            });
            page += 1;
          } while (products.length === 250);

          options.forEach((option) => {
            const label = option.dataset.stockCountLabel || option.dataset.flavorLabel;
            const count = counts.get(label.toLocaleLowerCase()) || 0;
            const isActive = option.classList.contains('is-active') ||
              option.querySelector('.collection-all-flavor__button')?.classList.contains('is-active');
            option.dataset.hasStock = count > 0 || isActive ? 'true' : 'false';
            const countBadge = option.querySelector('[data-stock-count], small');
            if (countBadge) {
              countBadge.textContent = count;
              countBadge.setAttribute('aria-busy', 'false');
            }
          });

          stockCounter.querySelector('[data-flavor-search]')?.dispatchEvent(new Event('input'));
        } catch (error) {
          stockCounter.querySelectorAll('[data-stock-count]').forEach((countBadge) => {
            countBadge.textContent = '—';
            countBadge.setAttribute('aria-label', stockCounter.dataset.stockCountError);
            countBadge.setAttribute('aria-busy', 'false');
          });
          console.error(error);
        } finally {
          if (loading) loading.hidden = true;
          if (content) content.hidden = false;
          flavorFilter?.classList.remove('is-stock-loading');
          flavorFilter?.setAttribute('aria-busy', 'false');
          stockCounter.setAttribute('aria-busy', 'false');
        }
      });
    };

    initializeStockCounts();

    if (window.collectionInfiniteScrollInitialized) return;
    window.collectionInfiniteScrollInitialized = true;

    const sentinelSelector = '[data-collection-infinite-scroll]';
    const handleIntersections = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) loadNextPage(entry.target);
      });
    };
    const observer = new IntersectionObserver(handleIntersections, { rootMargin: '800px 0px' });
    const scrollGatedObserver = new IntersectionObserver(handleIntersections);
    const observerForSentinel = (sentinel) =>
      sentinel.dataset.waitForScroll === 'true' ? scrollGatedObserver : observer;

    const setState = (sentinel, state) => {
      const status = sentinel.querySelector('[data-infinite-scroll-status]');
      const retry = sentinel.querySelector('[data-infinite-scroll-retry]');
      sentinel.classList.toggle('is-loading', state === 'loading');
      sentinel.classList.toggle('is-complete', state === 'complete');
      retry.hidden = state !== 'error';

      const messages = {
        loading: sentinel.dataset.loadingMessage,
        complete: sentinel.dataset.completeMessage,
        error: sentinel.dataset.errorMessage,
      };
      status.textContent = messages[state] || '';
    };

    const loadNextPage = async (sentinel) => {
      const currentContainer = sentinel.closest('#ProductGridContainer');
      const currentGrid = currentContainer?.querySelector('#product-grid');
      const hiddenItems = Array.from(currentGrid?.children || []).filter((item) => item.hidden);
      let productsWereLoaded = false;
      if (sentinel.dataset.loading === 'true' || (!sentinel.dataset.nextUrl && hiddenItems.length === 0)) return;

      sentinel.dataset.loading = 'true';
      observerForSentinel(sentinel).unobserve(sentinel);
      setState(sentinel, 'loading');

      try {
        if (!currentGrid) throw new Error('Collection product grid was not found');

        if (hiddenItems.length > 0) {
          const batchSize = Number.parseInt(sentinel.dataset.productBatchSize, 10) || hiddenItems.length;
          hiddenItems.slice(0, batchSize).forEach((item) => item.removeAttribute('hidden'));
          productsWereLoaded = true;
        } else {
          const nextUrl = new URL(sentinel.dataset.nextUrl, window.location.origin);
          nextUrl.searchParams.set('section_id', sentinel.dataset.sectionId);
          const response = await fetch(nextUrl, {
            credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          });
          if (!response.ok) throw new Error(`Collection page returned ${response.status}`);

          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const nextGrid = html.querySelector('#product-grid');
          if (!nextGrid) throw new Error('Collection product grid was not found');
          if (!sentinel.isConnected) return;

          const loadedProductIds = new Set(
            Array.from(currentGrid.querySelectorAll('[data-product-id]')).map((item) => item.dataset.productId)
          );
          const fragment = document.createDocumentFragment();
          Array.from(nextGrid.children).forEach((item) => {
            if (!item.dataset.productId || !loadedProductIds.has(item.dataset.productId)) fragment.append(item);
          });
          productsWereLoaded = fragment.childElementCount > 0;
          currentGrid.append(fragment);

          const nextSentinel = html.querySelector(sentinelSelector);
          sentinel.dataset.nextUrl = nextSentinel?.dataset.nextUrl || '';
        }

        if (typeof initializeScrollAnimationTrigger === 'function') {
          initializeScrollAnimationTrigger(currentGrid);
        }

        sentinel.dataset.loading = 'false';
        const hasHiddenItems = Array.from(currentGrid.children).some((item) => item.hidden);

        if (sentinel.dataset.nextUrl || hasHiddenItems) {
          setState(sentinel, 'idle');
          if (sentinel.dataset.waitForScroll === 'true') {
            observeAfterScroll(sentinel);
          } else {
            observerForSentinel(sentinel).observe(sentinel);
          }
        } else {
          setState(sentinel, 'complete');
        }
      } catch (error) {
        sentinel.dataset.loading = 'false';
        if (productsWereLoaded) {
          const hasHiddenItems = Array.from(currentGrid?.children || []).some((item) => item.hidden);
          if (sentinel.dataset.nextUrl || hasHiddenItems) {
            setState(sentinel, 'idle');
            observerForSentinel(sentinel).observe(sentinel);
          } else {
            setState(sentinel, 'complete');
          }
        } else {
          setState(sentinel, 'error');
        }
        console.error(error);
      }
    };

    const observeAfterScroll = (sentinel) => {
      const initialScrollPosition = window.scrollY;
      const handleScroll = () => {
        if (window.scrollY === initialScrollPosition) return;
        window.removeEventListener('scroll', handleScroll);
        const currentGrid = sentinel.closest('#ProductGridContainer')?.querySelector('#product-grid');
        const hasHiddenItems = Array.from(currentGrid?.children || []).some((item) => item.hidden);
        if (sentinel.isConnected && (sentinel.dataset.nextUrl || hasHiddenItems)) {
          observerForSentinel(sentinel).observe(sentinel);
        }
      };

      window.addEventListener('scroll', handleScroll, { passive: true });
    };

    const initialize = (container = document) => {
      const sentinels = [];
      if (container.matches?.(sentinelSelector)) sentinels.push(container);
      sentinels.push(...container.querySelectorAll(sentinelSelector));

      sentinels.forEach((sentinel) => {
        if (sentinel.dataset.initialized === 'true') return;
        const currentGrid = sentinel.closest('#ProductGridContainer')?.querySelector('#product-grid');
        const hasHiddenItems = Array.from(currentGrid?.children || []).some((item) => item.hidden);
        if (sentinel.dataset.currentPage !== '1' || (!sentinel.dataset.nextUrl && !hasHiddenItems)) return;
        sentinel.dataset.initialized = 'true';
        sentinel.classList.add('is-active');
        const pagination = sentinel.previousElementSibling;
        if (pagination?.classList.contains('pagination-wrapper')) pagination.hidden = true;
        sentinel.querySelector('[data-infinite-scroll-retry]').addEventListener('click', () => loadNextPage(sentinel));
        if (sentinel.dataset.waitForScroll === 'true') {
          observeAfterScroll(sentinel);
        } else {
          observerForSentinel(sentinel).observe(sentinel);
        }
      });
    };

    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            initializeFlavorControls(node);
            initializeSortButtons(node);
            initializeStockCounts(node);
            initialize(node);
          }
        });
      });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    } else {
      initialize();
    }
    mutationObserver.observe(document.documentElement, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sku-product-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!window.sharedSkuGridViewMoreInitialized) {
      window.sharedSkuGridViewMoreInitialized = true;
      document.addEventListener('click', (event) => {
        const button = event.target.closest('[data-shared-sku-grid-view-more]');
        if (!button) return;

        const root = button.closest('[data-sku-product-grid]');
        root.querySelectorAll('[data-shared-sku-grid-item][hidden]').forEach((item) => item.removeAttribute('hidden'));
        root.querySelector('[data-sku-grid-view-more-container]')?.setAttribute('hidden', '');
        root.querySelector('[data-sku-grid-view-all-container]')?.removeAttribute('hidden');
      });
    }

    const catalogPromises = new Map();
    let gridObserver;

    const createElement = (tag, className, text) => {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text !== undefined) element.textContent = text;
      return element;
    };

    const appendFormattedPrice = (element, amount, formatter) => {
      const parts = formatter.formatToParts(amount);

      parts.forEach((part, index) => {
        const fraction = parts[index + 1];
        if (part.type === 'decimal' && fraction?.type === 'fraction' && fraction.value === '99') {
          element.append(createElement('span', 'sku-product-grid__price-cents', fraction.value));
        } else if (part.type !== 'fraction' || parts[index - 1]?.type !== 'decimal' || part.value !== '99') {
          element.append(document.createTextNode(part.value));
        }
      });
    };

    const createSvgIcon = (type) => {
      const namespace = 'http://www.w3.org/2000/svg';
      const svg = document.createElementNS(namespace, 'svg');
      svg.classList.add('sku-product-grid__icon', `sku-product-grid__icon--${type}`);
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', 'currentColor');
      svg.setAttribute('stroke-width', '1.8');
      svg.setAttribute('stroke-linecap', 'round');
      svg.setAttribute('stroke-linejoin', 'round');

      const paths = {
        cart: ['M3 4h2l2.2 10.2a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 1.9-1.4L21 7H6', 'M10 20h.01', 'M17 20h.01'],
        plus: ['M12 5v14', 'M5 12h14'],
        check: ['m5 12 4 4L19 6'],
        error: ['M12 8v5', 'M12 17h.01', 'M12 3 2 5h5l-4 3 1.5 5L12 13l-4.5 3L9 11 5 8h5z'],
      };

      (paths[type] || paths.cart).forEach((pathData) => {
        const path = document.createElementNS(namespace, 'path');
        path.setAttribute('d', pathData);
        svg.append(path);
      });

      return svg;
    };

    const setQuickAddState = (button, state, root) => {
      const labels = {
        idle: root.dataset.addLabel,
        loading: root.dataset.addingLabel,
        success: root.dataset.addedLabel,
        error: root.dataset.cartErrorLabel,
      };
      const label = labels[state] || labels.idle;
      button.replaceChildren();

      if (state === 'loading') {
        button.append(createElement('span', 'sku-product-grid__quick-add-spinner'));
      } else {
        const iconType = state === 'success'
          ? 'check'
          : state === 'error'
            ? 'error'
            : root.dataset.quickAddIcon || 'cart';
        button.append(createSvgIcon(iconType));
      }

      button.title = label;
      button.setAttribute('aria-label', `${label}: ${button.dataset.productLabel}`);
    };

    const cleanProductTitles = (container = document) => {
      const selector = '.product-card-wrapper .card__heading a, .sku-product-grid__title, .lit-product-title';
      const elements = [];
      if (container.matches?.(selector)) elements.push(container);
      elements.push(...container.querySelectorAll(selector));

      elements.forEach((element) => {
        const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
        const textNodes = [];
        while (walker.nextNode()) textNodes.push(walker.currentNode);

        textNodes.forEach((node) => {
          const cleaned = node.nodeValue.replace(/\s*THCA\s+Flower\b/gi, '').replace(/\s{2,}/g, ' ').trim();
          if (cleaned !== node.nodeValue) node.nodeValue = cleaned;
        });
      });
    };

    const matchingVariant = (product, skuCodes) => {
      const matches = (product.variants || []).filter((variant) => {
        const sku = String(variant.sku || '').toUpperCase();
        return variant.available && (skuCodes.length === 0 || skuCodes.some((code) => sku.includes(code)));
      });

      matches.sort((left, right) => Number.parseFloat(left.price) - Number.parseFloat(right.price));
      return matches[0];
    };

    const productImage = (product, variant) => {
      if (variant.featured_image && variant.featured_image.src) return variant.featured_image.src;

      const variantImage = (product.images || []).find((image) =>
        (image.variant_ids || []).some((id) => String(id) === String(variant.id))
      );

      return variantImage?.src || product.images?.[0]?.src || '';
    };

    const strainType = (product) => {
      const tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',');
      const strain = tags
        .map((tag) => tag.trim().toLowerCase())
        .find((tag) => ['indica', 'sativa', 'hybrid'].includes(tag));

      return strain || 'hybrid';
    };

    const variantTier = (variant) => {
      const tier = String(variant.title || '').match(/\b(essential|preferred|supreme)\b/i)?.[1];
      return tier ? `${tier.charAt(0).toUpperCase()}${tier.slice(1).toLowerCase()}` : '';
    };

    const resizedImage = (source) => {
      if (!source) return '';
      const url = new URL(source, window.location.origin);
      url.searchParams.set('width', '700');
      return url.toString();
    };

    const fetchCatalog = async (productsUrl) => {
      const products = [];

      for (let page = 1; page <= 20; page += 1) {
        const url = new URL(productsUrl, window.location.origin);
        url.searchParams.set('limit', '250');
        url.searchParams.set('page', String(page));

        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error(`Product feed returned ${response.status}`);

        const payload = await response.json();
        const batch = Array.isArray(payload.products) ? payload.products : [];
        products.push(...batch);

        if (batch.length < 250) break;
      }

      return products;
    };

    const loadCatalog = (productsUrl) => {
      if (!catalogPromises.has(productsUrl)) {
        const request = fetchCatalog(productsUrl).catch((error) => {
          catalogPromises.delete(productsUrl);
          throw error;
        });
        catalogPromises.set(productsUrl, request);
      }

      return catalogPromises.get(productsUrl);
    };

    const addToCart = async (button, variant, root) => {
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const formData = new FormData();
      formData.append('id', variant.id);
      formData.append('quantity', '1');

      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append(
          'sections',
          cart
            .getSectionsToRender()
            .map((section) => section.id)
            .join(',')
        );
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
      }

      button.disabled = true;
      setQuickAddState(button, 'loading', root);

      try {
        const response = await fetch(root.dataset.cartAddUrl, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
        });
        const cartData = await response.json();

        if (!response.ok || cartData.status) {
          throw new Error(cartData.description || cartData.message || root.dataset.cartErrorLabel);
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          await publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'sku-product-grid',
            productVariantId: String(variant.id),
            cartData,
          });
        }

        if (cart && typeof cart.renderContents === 'function') {
          cart.classList.remove('is-empty');
          cart.renderContents(cartData);
        }

        setQuickAddState(button, 'success', root);
        document.dispatchEvent(
          new CustomEvent('sku-product-grid:cart-added', { detail: { variantId: variant.id, cartData } })
        );
      } catch (error) {
        setQuickAddState(button, 'error', root);
        console.error(error);
      } finally {
        window.setTimeout(() => {
          button.disabled = false;
          setQuickAddState(button, 'idle', root);
        }, 1600);
      }
    };

    const renderCard = (match, index, root, formatter) => {
      const { product, variant } = match;
      const item = createElement('li', 'sku-product-grid__item sku-product-grid__item--entering');
      item.style.setProperty('--sku-grid-enter-delay', `${Math.min(index, 7) * 45}ms`);
      const productRoot = root.dataset.productRoot || '/products/';
      const productUrl = `${productRoot}${encodeURIComponent(product.handle)}?variant=${encodeURIComponent(variant.id)}`;
      const mediaFrame = createElement('div', 'sku-product-grid__media-frame');
      const mediaLink = createElement('a', 'sku-product-grid__media-link');
      const infoLink = createElement('a', 'sku-product-grid__info-link');
      mediaLink.href = productUrl;
      infoLink.href = productUrl;

      const media = createElement('div', 'sku-product-grid__media');
      const imageSource = productImage(product, variant);

      if (imageSource) {
        const image = createElement('img', 'sku-product-grid__image');
        image.src = resizedImage(imageSource);
        image.alt = product.title;
        image.width = 700;
        image.height = 700;
        image.loading = root.dataset.deferredQuery === 'true' && index < Number(root.dataset.limit)
          ? 'eager'
          : root.dataset.imagePriority === 'high' && index < 4
            ? 'eager'
            : 'lazy';
        image.decoding = 'async';
        media.append(image);
      }

      const currentPrice = Number.parseFloat(variant.price);
      const compareAtPrice = Number.parseFloat(variant.compare_at_price);
      const isOnSale = Number.isFinite(compareAtPrice) && compareAtPrice > currentPrice;

      if (isOnSale) {
        media.append(createElement('span', 'sku-product-grid__sale-pill', root.dataset.saleLabel));
      }

      const strain = root.dataset.showStrainTags === 'false' ? '' : strainType(product);

      const variantSku = String(variant.sku || '').toUpperCase();
      if (variantSku.includes('SMALL-OZ-RETAIL')) {
        media.append(createElement('span', 'sku-product-grid__smalls-pill', root.dataset.smallsLabel));
      }

      const info = createElement('div', 'sku-product-grid__info');
      const headingRow = createElement('div', 'sku-product-grid__heading-row');
      const titleGroup = createElement('div', 'sku-product-grid__title-group');
      const title = createElement('h3', 'sku-product-grid__title', product.title);
      const tier = variantTier(variant);
      const price = createElement(
        'div',
        `sku-product-grid__price${isOnSale ? ' sku-product-grid__price--on-sale' : ''}`
      );

      const currentPriceElement = createElement('span', 'sku-product-grid__current-price');
      appendFormattedPrice(currentPriceElement, currentPrice, formatter);
      price.append(currentPriceElement);

      if (isOnSale) {
        const compare = createElement('s', 'sku-product-grid__compare-price');
        appendFormattedPrice(compare, compareAtPrice, formatter);
        price.append(compare);
      }

      titleGroup.append(title);
      if (tier || strain) {
        headingRow.classList.add('sku-product-tile__heading-row--homepage-meta');
        const subtitle = createElement('p', 'sku-product-tile__variant sku-product-tile__variant--homepage');

        if (tier) subtitle.append(createElement('span', 'sku-product-tile__tier', tier));
        if (strain) {
          const strainLabel = `${strain.charAt(0).toUpperCase()}${strain.slice(1)}`;
          subtitle.append(
            createElement('span', `sku-product-tile__strain sku-product-tile__strain--${strain}`, strainLabel)
          );
        }
        headingRow.append(titleGroup, price, subtitle);
      } else {
        headingRow.append(titleGroup, price);
      }
      info.append(headingRow);
      const quickAdd = createElement('button', 'sku-product-grid__quick-add');
      quickAdd.type = 'button';
      quickAdd.dataset.productLabel = `${product.title}, ${variant.title}`;
      setQuickAddState(quickAdd, 'idle', root);
      quickAdd.addEventListener('click', () => addToCart(quickAdd, variant, root));
      mediaLink.append(media);
      mediaFrame.append(mediaLink, quickAdd);
      infoLink.append(info);
      item.append(mediaFrame, infoLink);
      return item;
    };

    const waitForCardImages = (cards) => Promise.all(
      cards.flatMap((card) => Array.from(card.querySelectorAll('img'))).map((image) => {
        if (image.complete) return Promise.resolve();

        return new Promise((resolve) => {
          image.addEventListener('load', resolve, { once: true });
          image.addEventListener('error', resolve, { once: true });
        });
      })
    );

    const initialize = async (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      root.dataset.loadState = 'loading';

      const grid = root.querySelector('[data-sku-grid]');
      const status = root.querySelector('[data-sku-grid-status]');
      const viewMoreContainer = root.querySelector('[data-sku-grid-view-more-container]');
      const viewMoreButton = root.querySelector('[data-sku-grid-view-more]');
      const viewAllContainer = root.querySelector('[data-sku-grid-view-all-container]');
      const limit = Number.parseInt(root.dataset.limit, 10) || 25;
      const maxProducts = Number.parseInt(root.dataset.maxProducts, 10) || limit;
      const skuCodes = String(root.dataset.skuCodes || '')
        .split(',')
        .map((code) => code.trim().toUpperCase())
        .filter(Boolean);
      const currency = root.dataset.currency || 'USD';
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency,
      });

      try {
        const products = await loadCatalog(root.dataset.productsUrl);
        const matches = products
          .map((product) => ({ product, variant: matchingVariant(product, skuCodes) }))
          .filter((match) => match.variant)
          .sort((left, right) => {
            const priceDifference = Number.parseFloat(left.variant.price) - Number.parseFloat(right.variant.price);
            return priceDifference || left.product.title.localeCompare(right.product.title);
          })
          .slice(0, maxProducts);

        grid.replaceChildren();

        if (matches.length === 0) {
          grid.setAttribute('aria-busy', 'false');
          if (viewMoreContainer) viewMoreContainer.hidden = true;
          if (viewAllContainer) viewAllContainer.hidden = true;
          status.textContent = root.dataset.emptyMessage;
          root.dataset.loadState = 'complete';
          return;
        }

        let renderedCount = 0;
        const renderNextBatch = () => {
          const nextMatches = matches.slice(renderedCount, renderedCount + limit);
          const cards = nextMatches.map((match, index) => renderCard(match, renderedCount + index, root, formatter));
          grid.append(...cards);
          renderedCount += nextMatches.length;
          const hasMoreProducts = renderedCount < matches.length;
          if (viewMoreContainer) viewMoreContainer.hidden = !hasMoreProducts;
          if (viewAllContainer) viewAllContainer.hidden = hasMoreProducts;
          cleanProductTitles(document);

          window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
              cards.forEach((card) => card.classList.remove('sku-product-grid__item--entering'));
            });
          });

          return cards;
        };

        if (viewMoreButton) viewMoreButton.addEventListener('click', renderNextBatch);
        const initialCards = renderNextBatch();
        await waitForCardImages(initialCards);
        grid.setAttribute('aria-busy', 'false');
        status.replaceChildren();
        window.requestAnimationFrame(() => {
          root.dataset.loadState = 'complete';
        });
      } catch (error) {
        grid.replaceChildren();
        grid.setAttribute('aria-busy', 'false');
        status.textContent = root.dataset.errorMessage;
        root.dataset.loadState = 'complete';
        console.error(error);
      }
    };

    const initializeWhenNeeded = (root) => {
      if (root.dataset.initialized === 'true') return;

      const firstGrid = document.querySelector('[data-sku-product-grid]');
      if (root === firstGrid && root.dataset.deferredQuery !== 'true') {
        root.dataset.imagePriority = 'high';
        initialize(root);
        return;
      }

      if (!('IntersectionObserver' in window)) {
        initialize(root);
        return;
      }

      if (!gridObserver) {
        gridObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              gridObserver.unobserve(entry.target);
              initialize(entry.target);
            });
          },
          { rootMargin: '0px', threshold: 0.01 }
        );
      }

      gridObserver.observe(root);
    };

    const sortSharedGrid = (root) => {
      const grid = root.querySelector('[data-sku-grid]');
      const limit = Number.parseInt(root.dataset.limit, 10) || 25;
      const items = Array.from(grid?.querySelectorAll('[data-shared-sku-grid-item]') || []);
      if (items.length === 0) return;

      items.sort((left, right) => {
        const leftTile = left.querySelector('[data-sku-product-tile-price]');
        const rightTile = right.querySelector('[data-sku-product-tile-price]');
        const priceDifference = Number.parseInt(leftTile?.dataset.skuProductTilePrice || '0', 10)
          - Number.parseInt(rightTile?.dataset.skuProductTilePrice || '0', 10);
        return priceDifference || String(leftTile?.dataset.skuProductTileTitle || '')
          .localeCompare(String(rightTile?.dataset.skuProductTileTitle || ''));
      });

      items.forEach((item, index) => {
        item.hidden = index >= limit;
        grid.append(item);
      });
    };

    const initializeAll = (container = document) => {
      cleanProductTitles(container);
      const roots = [];
      if (container.matches?.('[data-sku-product-grid]')) roots.push(container);
      roots.push(...container.querySelectorAll('[data-sku-product-grid]'));
      roots.forEach((root) => {
        sortSharedGrid(root);
        initializeWhenNeeded(root);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));

    const titleObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) cleanProductTitles(node);
        });
      });
    });
    titleObserver.observe(document.documentElement, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
